export type UnwrappedSettledResult<T, E extends Error = Error> = { fulfilled: Array<T>, rejected: Array<E> }
export const unwrapSettled = async <T = any> (
  payload: Promise<PromiseSettledResult<any>[]> |
  Array<PromiseSettledResult<T>> |
  UnwrappedSettledResult<T>): Promise<UnwrappedSettledResult<T>> => {
  // if already split, return
  if (!Array.isArray(payload) && 'fulfilled' in payload && 'rejected' in payload) return payload

  // await in case the payload is a promise
  const result:Array<PromiseSettledResult<T>> = await payload

  // reduce the result based on the settled status
  return result.reduce<{ fulfilled: Array<T>, rejected: Array<Error> }>((value, next) => {
    if (next.status === 'fulfilled') value.fulfilled.push(next.value)
    if (next.status === 'rejected') value.rejected.push(next.reason)

    return value
  }, { fulfilled: [], rejected: [] })
}

export const $unwrap = {
  settled: unwrapSettled
}

export function $settle <T>(payload: Array<Promise<T>>): Promise<UnwrappedSettledResult<T>>
export function $settle <T,U extends boolean>(payload: Array<Promise<T>>, unwrap?: U): U extends true ? Promise<UnwrappedSettledResult<T>> : Promise<PromiseSettledResult<T>>
export function $settle <T,U extends boolean> (payload: Array<Promise<T>>, unwrap?: U):
U extends true ? Promise<UnwrappedSettledResult<T>> : Promise<PromiseSettledResult<T>> {
  return unwrap === false ? Promise.allSettled<Promise<T>[]>(payload) as any : $unwrap.settled<T>(Promise.allSettled<Promise<T>[]>(payload))
}
